import { render, staticRenderFns } from "./platformOperationProcess.vue?vue&type=template&id=69b88381&scoped=true&"
import script from "./platformOperationProcess.vue?vue&type=script&lang=js&"
export * from "./platformOperationProcess.vue?vue&type=script&lang=js&"
import style0 from "./platformOperationProcess.vue?vue&type=style&index=0&id=69b88381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b88381",
  null
  
)

export default component.exports